import { memo } from "react";

const meaningsDefualt = [
    ['M1-T1 : ', 'EPP - Colócate el casco'],
    ['M1-T2 : ', 'EPP - Colócate los lentes de seguridad'],
    ['M1-T3 : ', 'EPP - Colócate los tapones auditivos'],
    ['M1-T4 : ', 'EPP - Colócate la camisola de alta visibilidad'],
    ['M1-T5 : ', 'EPP - Colócate los guantes de carnaza'],
    ['M1-T6 : ', 'EPP - Colócate las botas de seguridad'],
    ['M2-T1 : ', 'Previo a utilizar canalones - TOMA 5'],
    ['M2-T2 : ', 'Previo a utilizar canalones - Desciende del camión'],
    ['M2-T3 : ', 'Previo a utilizar canalones - Colocación de calzas'],
    ['M2-T4 : ', 'Previo a utilizar canalones - Revisa el perímetro'],
    ['M2-T5 : ', 'Previo a utilizar canalones - Coloca los conos'],
    ['M3-T1 : ', 'Despliegue inicial y extensión de canalón - Despliega el canalón principal'],
    ['M3-T2 : ', 'Despliegue inicial y extensión de canalón - Colecta la extensión de canalón'],
    ['M3-T3 : ', 'Despliegue inicial y extensión de canalón - Ensambla los canalones'],
    ['M3-T4 : ', 'Despliegue inicial y extensión de canalón - Desplázate cuidadosamente'],
    ['M4-T1 : ', 'Plegar al final de la descarga - Retiro de extensión de canalón'],
    ['M4-T2 : ', 'Plegar al final de la descarga - Guarda y asegura la extensión'],
    ['M4-T3 : ', 'Plegar al final de la descarga - Pliega el canalón principal'],
    ['M4-T4 : ', 'Plegar al final de la descarga - Retira los conos'],
    ['M4-T5 : ', 'Plegar al final de la descarga - Guarda las calzas'],
]
const Meanings = ({ meanings = meaningsDefualt }) => {
    return (
        <section className="w-[240px] min-w-[240px] h-[432px] bg-white p-4 rounded-2xl flex flex-col">
            <h3 className="text-center text-[#282828] font-semibold bg-white text-sm h-5 mb-5">Índice de tareas</h3>
            <ul className="text-left flex-1 overflow-auto">
                {meanings.map(([title, meaning]) => (
                    <li key={title} className="text-[#686868] bg-white text-[8px] font-medium mb-1 flex justify-start w-full">
                        <div className="w-2/6 font-extrabold">{title}</div>
                        <div className="flex-1">{meaning}</div>
                    </li>
                ))}
            </ul>
        </section>
    );
}

export default memo(Meanings);